import { useParams } from "react-router-dom";
import PrivacyPolicyClient from "../../components/legal/PrivacyPolicyClient";
import { normalizeLocale } from "../../utils/locales";

export default function PrivacyPolicyPage() {
  const { locale } = useParams();
  const loc = normalizeLocale(locale);
  return <PrivacyPolicyClient locale={loc} />;
}
